import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as S from './ErrorCard.styles';
export const ErrorCard = ({ closeCard, message }) => {
    return (_jsxs(S.ErrorCard, { children: [_jsx(S.ErrorIcon, {}), _jsx(S.ErrorMessage, { children: message }), closeCard ? (_jsx("div", Object.assign({ onClick: closeCard }, { children: _jsx(S.CloseIcon, {}) }))) : null] }));
};
